import React, { useContext } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #fff;
  padding: 26px 0;
  .items {
    display: flex;
    div {
      flex-grow: 1;
    }
    span,
    a {
      text-decoration: none;
      color: #40403F;
      font: 300 14px Montserrat;
      &:before {
        content: ' > ';
      }
      &:first-child {
        &:before {
          content: '';
        }
      }
      &.back {
        font-weight: 600;
        &:before {
          content: ' ';
          background: url(/images/arrow-left.png) center no-repeat;
          width: 15px;
          height: 15px;
          margin-right: 10px;
          display: inline-block;
          background-size: contain;
          vertical-align: middle;
        }
        &:hover {
          text-decoration: underline;
        }
        @media (max-width: 789px) {
          display: none;
        }
      }
    }
  }
  .line {
    display: block;
    margin-top: 40px;
    font-weight: 600;
    color: #979797;
    font-size: 22px;
  }
  strong {
    margin-top: 12px;
    font: italic bold 46px 'Times new roman';
    display: block;
  }
`

const ProductHeader = ({nome, categoria, tipo}) => {
  const { language } = useContext(LanguageContext);
  let inicio = ''
  let voltar = ''
  switch (language) {
    case 'pt-br':
      inicio = 'Início';
      voltar = 'Voltar para produtos';
      break;
    case 'en-us':
      inicio = 'Home';
      voltar = 'Back to products';
      break;
    case 'es-es':
      inicio = 'Início';
      voltar = 'Volver a productos';
      break;
    default:
  }
  return (
    <Container>
      <div className="wrapper">
        <div className="items">
          <div>
            <Link to="/">{ inicio }</Link>
            {
              (tipo && tipo.data) && (
                <span>{ tipo.data.tipo }</span>
              )
            }
            {
              tipo.data && (
                <Link to={ `/produtos/${tipo.uid}` }>{ tipo.data.nome[0].text }</Link>
              )
            }
            <span>{ nome[0].text }</span>
          </div>
          <Link to={ `/produtos/${tipo.uid}` } className="back">
            <i></i>
            { voltar }
          </Link>
        </div>
        {
          (categoria && categoria.data && categoria.data.nome) && (
            <span className="line">{ categoria.data.nome[0].text }</span>
          )
        }
        <strong>{ nome[0].text }</strong>
      </div>
    </Container>
  )
}

export default ProductHeader;
